import { render, staticRenderFns } from "./DialgoHeader.vue?vue&type=template&id=882d51c8&scoped=true&"
import script from "./DialgoHeader.vue?vue&type=script&lang=ts&"
export * from "./DialgoHeader.vue?vue&type=script&lang=ts&"
import style0 from "./DialgoHeader.vue?vue&type=style&index=0&id=882d51c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "882d51c8",
  null
  
)

export default component.exports